/**
 * NIL Go for the app (shared/nilGo.ts): reading a deal's state on the signed-in
 * session, changing it through the server route, the only way in.
 */

import { pb } from '../lib/pocketbase'
import { readNilGoState, type NilGoState, type NilGoStatus } from '../shared/nilGo'

export type NilGoBody =
  | { action: 'status'; status: NilGoStatus; date?: string; note?: string; reference?: string }
  | { action: 'agreed_on'; date: string }
  | { action: 'override'; reason: string }
  | { action: 'end_override' }

export const getNilGoState = (dealId: string): Promise<NilGoState | null> => readNilGoState(pb as any, dealId)

export async function nilGoAction(dealId: string, body: NilGoBody): Promise<{ state: NilGoState | null }> {
  const res = await fetch('/api/nil-go', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${pb.authStore.token}` },
    body: JSON.stringify({ deal_id: dealId, ...body }),
  })
  const data = await res.json().catch(() => null)
  if (!res.ok || !data) throw new Error(data?.error || `NIL Go could not be saved (${res.status}).`)
  return data
}
